var _defs, _path, _path2, _path3, _path4, _circle, _path5, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1f3060;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #ccc;\n      }\n\n      .cls-4 {\n        fill: #facb6f;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.85,86h655.79v843.16H115.85V86Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M771.65,86H162.69v718.25c0,43.11,34.96,78.07,78.07,78.07h530.88V86Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M209.54,773.02c-8.6,0-15.61-7-15.61-15.61s7.01-15.61,15.61-15.61,15.61,7,15.61,15.61h31.23c0-20.33-13.1-37.51-31.23-43.97v-18.49h-31.23v18.49c-18.13,6.46-31.23,23.64-31.23,43.97,0,25.83,21.02,46.84,46.84,46.84,8.6,0,15.61,7,15.61,15.61s-7.01,15.61-15.61,15.61-15.61-7-15.61-15.61h-31.23c0,20.33,13.1,37.51,31.23,43.97v18.49h31.23v-18.49c18.13-6.46,31.23-23.64,31.23-43.97,0-25.83-21.02-46.84-46.84-46.84Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M178.31,304.6h156.14v187.37h-156.14v-187.37Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.38,
    cy: 382.67,
    r: 31.23
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178.31,491.97l13.83-34.59c10.51-26.26,35.94-43.49,64.24-43.49s53.73,17.22,64.24,43.49l13.83,34.59"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M256.38,257.76h62.46v-31.23h-46.84v-93.68h-31.23v109.3c0,8.63,7,15.61,15.61,15.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M350.06,257.76h62.46c8.62,0,15.61-6.98,15.61-15.61v-93.68c0-8.63-7-15.61-15.61-15.61h-62.46c-8.62,0-15.61,6.98-15.61,15.61v93.68c0,8.63,7,15.61,15.61,15.61ZM365.68,164.07h31.23v62.46h-31.23v-62.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M474.98,226.53h31.23v31.23h31.23v-62.46c0-3.08-.92-6.11-2.62-8.67l-31.23-46.84c-5.79-8.7-20.19-8.7-25.98,0l-31.23,46.84c-1.7,2.56-2.62,5.59-2.62,8.67v62.46h31.23v-31.23ZM503.05,195.3h-24.92l12.46-18.69,12.46,18.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M584.28,200.03l33.85,50.78c2.95,4.42,7.87,6.95,12.99,6.95,1.51,0,3.03-.22,4.53-.67,6.57-2,11.09-8.07,11.09-14.94v-109.3h-31.23v57.73l-33.85-50.78c-3.83-5.71-10.93-8.29-17.52-6.28-6.57,2-11.09,8.07-11.09,14.94v109.3h31.23v-57.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M350.06,741.79h140.53v31.23h-140.53v-31.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M287.61,804.25h202.98v31.23h-202.98v-31.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M521.82,288.98h202.98v31.23h-202.98v-31.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M381.29,351.44h343.51v31.23h-343.51v-31.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M381.29,413.9h343.51v31.23h-343.51v-31.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M381.29,476.35h343.51v31.23h-343.51v-31.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.69,538.81h296.67v31.23H162.69v-31.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.69,601.27h234.21v31.23h-234.21v-31.23Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 693.57,
    cy: 788.64,
    r: 234.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M693.57,554.42c-38,0-73.76,9.24-105.5,25.31-50.04,42.95-81.87,106.55-81.87,177.67,0,129.35,104.86,234.21,234.21,234.21,38,0,73.76-9.24,105.5-25.31,50.04-42.95,81.87-106.55,81.87-177.67,0-129.35-104.86-234.21-234.21-234.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M537.43,804.25l46.84-46.84,62.46,62.46,156.14-156.14,46.84,46.84-202.98,202.98-109.3-109.3Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNine);
export default __webpack_public_path__ + "static/media/nine.7f1c84e9840d84444a044e4765998ce7.svg";
export { ForwardRef as ReactComponent };